import { NavLink } from "react-router-dom";
import { WEB_ROUTES } from "../routes/web-routes";

export default function GalleryItem({ article, galleryMedia }) {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return (
    <>
      <div className="flex flex-col">
        <NavLink
          to={WEB_ROUTES.GALLERY + `/` + article?.slug}
          className="group relative block w-full overflow-hidden"
        >
          <img
            src={galleryMedia?.source_url}
            alt={article?.title?.rendered}
            className="w-full h-72 object-cover transition duration-300 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all duration-300" />
          {article?.date && (
            <div className="absolute top-0 left-0 bg-[#58b947] py-2 px-6 text-lg font-medium">
              <span className="text-white">
                <span
                  dangerouslySetInnerHTML={{
                    __html:
                      monthNames[new Date(article?.date).getMonth()] +
                      " " +
                      new Date(article?.date).getFullYear(),
                  }}
                />
              </span>
            </div>
          )}
        </NavLink>
        <div className="mt-1">
          <h3 className="font-bold md:text-2xl text-lg my-2">
            <NavLink className="" to={WEB_ROUTES.GALLERY + `/` + article?.slug}>
              <span
                dangerouslySetInnerHTML={{
                  __html: article?.title?.rendered,
                }}
              />
            </NavLink>
          </h3>

          <p
            className="text-gray-700 text-base leading-relaxed mb-6"
            dangerouslySetInnerHTML={{
              __html: article?.excerpt?.rendered,
            }}
          />

          <NavLink
            to={WEB_ROUTES.GALLERY + `/` + article?.slug}
            className="inline-flex items-center text-[#0070b9] font-medium transition-colors"
          >
            <span>View gallery</span>
            <svg
              className="ml-2 w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </NavLink>
        </div>
      </div>
    </>
  );
}
